export const isCypress = (): boolean => !!(window as unknown as { Cypress: string }).Cypress;
